import classNames from 'classnames/bind';
import styles from './DisabledAccount.module.css';

import useModal from '../../../hooks/useModal';
import { apiSlice } from '../../../services/api';

import Information from '../Information';
import {
  CONTACT_US_DESC,
  SERVICE_RESTRICTION_INFO,
  REASON,
  SERVICE_RESTRICTIONS,
  TERM,
  TERMS,
} from '../../../constants';

import { useLocation } from 'react-router-dom';

export default function DisabledAccount() {
  const cx = classNames.bind(styles);
  const { state } = useLocation();
  const { accountInfo } = state;
  const { suspensionDate, suspensionReason } = accountInfo;

  const { toggleModal } = useModal();

  const [getTerms] = apiSlice.useLazyGetTermsQuery();

  const displayedInfoList = [
    { title: REASON, value: suspensionReason },
    { title: TERM, value: suspensionDate },
  ];

  const openTerms = async () => {
    const agreeCd = 'T0101';
    try {
      const terms = await getTerms(agreeCd, true).unwrap();
      toggleModal({
        name: 'terms',
        id: agreeCd,
        type: 'content',
        data: terms,
      });
    } catch (error) {
      console.error('Failed to get terms', error);
    }
  };

  const TopDescription = () => (
    <span dangerouslySetInnerHTML={{ __html: SERVICE_RESTRICTIONS }}></span>
  );

  const Info = () => (
    <>
      {displayedInfoList.map(({ title, value }) => (
        <p key={title}>
          {title}: <span>{value}</span>
        </p>
      ))}
    </>
  );

  const BottomDescription = () => (
    <>
      <span className={cx('mb')}>
        <span className={cx('link_t', 'underline')} onClick={openTerms}>
          Selpub {TERMS}
        </span>
      </span>
      <span dangerouslySetInnerHTML={{ __html: CONTACT_US_DESC }}></span>
    </>
  );

  return (
    <>
      <Information title={SERVICE_RESTRICTION_INFO} info={accountInfo}>
        <TopDescription />
        <Info />
        <BottomDescription />
      </Information>
    </>
  );
}
